<template>
  <div>
    <TeCourseAiCover
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />

    <TeCommonPagenav class="hidden md:block">
      <template #courseicon>
        <FontAwesomeIcon
          :icon="faHeadSideBrain"
          class="fa-fw mr-2 size-5"
        />
      </template>
      <template #coursename>
        AI<span class="hidden md:inline">コース</span>
      </template>
    </TeCommonPagenav>

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />
    <TeCommonBannerCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <TeCourseAbout>
      <template #title>
        AIコースについて
      </template>
      <template #discription>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          1人では続かない方のためのパーソナルメンターがつく学習プログラム。
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          週2回マンツーマンでのメンタリング、毎日15〜23時のチャット・レビューサポートで
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          短期間でAI（人工知能）の構築に必要な機械学習・ディープラーニングを学べるプログラム。
        </p>
        <p class="co-display-10 mb-0 inline text-co-gray-500 md:block">
          Pythonのライブラリを使い、機械学習の応用までを実践的に学ぶことができます。
        </p>
      </template>
    </TeCourseAbout>

    <TeCourseAiTarget />

    <TeCommonDemographics />

    <TeCourseAiOutput />

    <TeCourseAiCurriculum />

    <TeCommonComparisonAiDatascience>
      <template #course>
        データサイエンス
      </template>
      <template #link>
        データサイエンスコースを<a :href="'/course/datascience'">詳しく見る</a>
      </template>
    </TeCommonComparisonAiDatascience>

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-first"
    /> -->

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport>
            <template #title>
              毎日15時〜23時の
            </template>
            <template #lead>
              メンターが毎日8時間常時オンラインで待機してるので疑問点を聞けばチャットですぐに回答がもらえます。
            </template>
          </TeCommonMentorSupportChatSupport>

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>
      <TeCommonMentorSupportAboutFlow>
        <template #flowOriginalText>
          オリジナルのAIの構築
        </template>
        <template #originalTitle>
          最終課題まで徹底サポート
        </template>
        <template #originalLead>
          受講目的や習得スキルに合わせて、手書き伝票の画像認識する機械学習を徹底サポートします。
        </template>
      </TeCommonMentorSupportAboutFlow>

      <TeCommonMentorSupportMentor>
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-ota.jpg"
            alt="Kazuki Ota"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Kazuki
          <br>
          Ota
        </template>
        <template #mentorProfile1>
          システムエンジニア歴約20年、プログラミング歴約35年。プログラミングの守備範囲はフロントエンド、サーバサイド、Android開発、機械学習と広く、また普段はシステム開発プロジェクトの管理や後輩の指導を行っています。
        </template>
        <template #mentorMessage1>
          プログラミングが出来るようになると世界が広がります！受講生様に寄り添い、楽しく学んで頂けるようサポートさせて頂きます。
        </template>
        <template #mentorImage2>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-saitoh.jpg"
            alt="Hitoshi Saitoh"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName2>
          Hitoshi
          <br>
          Saitoh
        </template>
        <template #mentorProfile2>
          国立研究開発法人の研究員として業務に従事。データサイエンティストとして、患者様の遺伝子配列データを用いた解析に日々邁進しております。技術の移り変わりに遅れを取らないよう、情報のアップデートが欠かせませんが、やりがいをもって取り組んでいます。
        </template>
        <template #mentorMessage2>
          プログラミングの学習は独学で行い、業務を通じて数多くの挑戦と挫折を経験しました。その経験を活かし、皆様が学習に取り組む際に寄り添い、心強いサポートを提供できればと考えております。一緒に成長していけることを心より楽しみにしております。
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason />
    </section>

    <TeCommonLearningCycle>
      <template #catchTwo>
        <span>機械学習プログラムを</span>
        <span class="text-co-primary-500">開発する</span>
      </template>
    </TeCommonLearningCycle>

    <TeCommonSliderVoice />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-second"
    /> -->

    <TeCommonCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-4 py-20 xl:px-0">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeCoursePriceTable
          :course="course"
          :latest-cohort="latestCohort"
          :current-promotion="currentPromotion"
          :student="true"
          :mentoring="true"
          :chat-support="true"
          :badge-sakiwari-and-campaign="true"
        />

        <TeCoursePriceGreatPlan :course="course" />

        <TeCoursePriceInstallments :course="course" />

        <!-- 早めの申し込み・入金がお得！バナー -->
        <TeCommonPricePreviously />

        <!-- 参加条件 -->
        <TeCommonPriceParticipationconditions>
          <template #conditionList>
            <li class="mb-2">
              Python3について理解している
            </li>
            <li class="mb-2">
              必要なメンタリング回数をこなすことが出来る
            </li>
            <li class="mb-2">
              期間内に必要な学習時間を確保出来る
            </li>
            <li class="mb-2">
              MacかWindowsのPCを持っている
            </li>
            <li class="mb-2">
              Macの場合：OS Ventura 13 以上
            </li>
            <li class="mb-2">
              Google Chrome を利用できる
            </li>
            <li class="mb-2">
              PCの基本的な操作が問題なくできる
            </li>
            <li>ビデオチャットが可能な通信環境</li>
          </template>
        </tecommonpriceparticipationconditions>

        <div class="flex flex-col items-center lg:flex-row lg:items-start lg:gap-x-8">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions />
          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <TeCourseSakiwari
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
    >
      <template #annotation02>
        <li>※4週間・8週間プランは先割の対象外です。</li>
      </template>
    </TeCourseSakiwari>

    <TeCommonTomowari
      bg="#00bfd0"
      title-bg="#00909d"
    />

    <!-- キャリアアップ支援事業 -->
    <TeCommonCareerUp
      :course="course"
      :course16weeks="true"
    />

    <TeCourseAiSetBanner :course="course" />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-third"
    /> -->

    <TeCommonCareerSupport />

    <TeCommonComparisonSchool :benefits="true" />

    <TeCourseMessage />

    <TeCourseAiFlow />

    <!-- 251202導線削除 -->
    <!-- <TeCourseAiFaQ /> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCourseApply
      :course="course"
      :cohorts="cohorts"
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
      :current-promotion="currentPromotion"
      :course-name-path="courseNamePath"
      :entry-discount-time-limit="entryDiscountTimeLimit"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import { getCohorts, getCurrentPromotion, getCourse } from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'

import TeCourseAiCover from '~/components/Te/TeCourse/Ai/TeCourseAiCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeCourseAbout from '~/components/Te/TeCourse/TeCourseAbout.vue'
import TeCourseAiTarget from '~/components/Te/TeCourse/Ai/TeCourseAiTarget.vue'
import TeCommonDemographics from '~/components/Te/TeCommon/TeCommonDemographics/TeCommonDemographics.vue'
import TeCourseAiOutput from '~/components/Te/TeCourse/Ai/TeCourseAiOutput.vue'
import TeCourseAiCurriculum from '~/components/Te/TeCourse/Ai/TeCourseAiCurriculum.vue'
import TeCommonComparisonAiDatascience from '~/components/Te/TeCommon/Comparison/TeCommonComparisonAiDatascience/TeCommonComparisonAiDatascience.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportAboutFlow from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportAboutFlow/TeCommonMentorSupportAboutFlow.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeCommonLearningCycle from '~/components/Te/TeCommon/TeCommonLearningCycle/TeCommonLearningCycle.vue'
import TeCommonSliderVoice from '~/components/Te/TeCommon/Slider/TeCommonSliderVoice/TeCommonSliderVoice.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeCoursePriceTable from '~/components/Te/TeCourse/TeCoursePriceTable.vue'
import TeCoursePriceGreatPlan from '~/components/Te/TeCourse/TeCoursePriceGreatPlan.vue'
import TeCoursePriceInstallments from '~/components/Te/TeCourse/TeCoursePriceInstallments.vue'
import TeCommonPricePreviously from '~/components/Te/TeCommon/Price/TeCommonPricePreviously/TeCommonPricePreviously.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeCourseSakiwari from '~/components/Te/TeCourse/TeCourseSakiwari.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeCourseAiSetBanner from '~/components/Te/TeCourse/Ai/TeCourseAiSetBanner.vue'
import TeCommonCareerSupport from '~/components/Te/TeCommon/TeCommonCareerSupport/TeCommonCareerSupport.vue'
import TeCommonComparisonSchool from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchool/TeCommonComparisonSchool.vue'
import TeCourseMessage from '~/components/Te/TeCourse/TeCourseMessage.vue'
import TeCourseAiFlow from '~/components/Te/TeCourse/Ai/TeCourseAiFlow.vue'
import TeCourseAiFaQ from '~/components/Te/TeCourse/Ai/TeCourseAiFaQ.vue'
import TeCourseApply from '~/components/Te/TeCourse/TeCourseApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHeadSideBrain } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = route.path.split('/')[2]
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
      faHeadSideBrain,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true,
      criteoScript: true,
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title:
        'AI(人工知能)を学習・勉強できる講座/受講者数No.1 | テックアカデミー',
      meta: [
        ...metaTags({
          description:
            '【テックアカデミー(TechAcademy)】選抜された現役エンジニアから学べるAI(人工知能)プログラミングの講座。受講者数No.1のオンラインプログラミングスクール。専属のパーソナルメンターがマンツーマンでサポート。転職サポートもあり。',
          twitterTitle: 'AIコース',
          twitterDescription:
            'AIプログラミングを選抜された現役エンジニアから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          twitterImage: '/_nuxt/ogp/te/tecourse/og-image-ai.jpg',
          ogTitle: 'AIコース',
          ogDescription:
            'AIプログラミングを選抜された現役エンジニアから自宅で学べる。パーソナルメンターがマンツーマンで学習サポート。',
          ogUrl: '/course/ai',
          ogImage: '/_nuxt/ogp/te/tecourse/og-image-ai.jpg',
        }),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    getCohorts(this.$api, {
      course_screen_name: this.courseNamePath,
      sakiwari: true,
    }).then((response) => {
      this.sakiwariCohorts = response.data
    })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })

    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCourseAiCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeCourseAbout,
    TeCourseAiTarget,
    TeCommonDemographics,
    TeCourseAiOutput,
    TeCourseAiCurriculum,
    TeCommonComparisonAiDatascience,
    TeCommonBannerFreeTrial,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportAboutFlow,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeCommonLearningCycle,
    TeCommonSliderVoice,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeCoursePriceTable,
    TeCoursePriceGreatPlan,
    TeCoursePriceInstallments,
    TeCommonPricePreviously,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeCourseSakiwari,
    TeCommonTomowari,
    TeCommonCareerUp,
    TeCourseAiSetBanner,
    TeCommonCareerSupport,
    TeCommonComparisonSchool,
    TeCourseMessage,
    TeCourseAiFlow,
    TeCourseAiFaQ,
    TeCourseApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
